import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_ALMACENAJE_ESPECIAL } from '../../../../config/tables'

function TotalAlmacenajeEspecialView () {
  return (
    <MuiTable id={TABLA_ALMACENAJE_ESPECIAL} />
  )
}

export default TotalAlmacenajeEspecialView
